import {Component} from '@angular/core';
import {BaseComponent} from '../../shared/base-components/base.component';

@Component({
    selector: '[login]',
    templateUrl: './api-request.html'
})

export class ApiRequestComponent extends BaseComponent {

    public headers: string;

    constructor(
    ) {
        super();

    }

    ngOnInit() {
        this.headers = 'Authorization: Bearer ' + this.auth.accessToken
            + '\r\n'
            + 'BUID: ' + this.auth.businessUnitId
            + '\r\n'
            + 'SecurityStamp: ' + this.auth.securityStamp
            + '\r\n';
    }
}
